import events from '../events/events';

function minimizeSidebar(event) {
    event.preventDefault();
    const sidebar = document.querySelector('[data-sidebar]');
    sidebar.classList.toggle('minimized');
}

function toggleSidebar(event) {
    event.preventDefault();
    const sidebar = document.querySelector('[data-sidebar]');
    document.querySelector('body').classList.toggle('scroll-lock');
    document.querySelectorAll('[data-toggle-sidebar]').forEach((el) => {
        el.classList.toggle('nav-btn_opened');
    });
    const offset = document.querySelector('.root-header').clientHeight - window.scrollY;
    sidebar.style.top = `${offset}px`;
    sidebar.classList.toggle('root-sidebar_opened');
}

events.on('breakpoint.change', (current) => {
    if (current.name === 'xl') {
        document.querySelector('body').classList.remove('scroll-lock');
        document.querySelectorAll('[data-toggle-sidebar]').forEach((el) => {
            el.classList.remove('nav-btn_opened');
        });
        document.querySelector('[data-sidebar]').classList.remove('root-sidebar_opened');
    }
});

export default function initSidebar() {
    document.querySelectorAll('[data-minimize-sidebar]').forEach((el) => {
        el.removeEventListener('click', minimizeSidebar);
    });
    document.querySelectorAll('[data-minimize-sidebar]').forEach((el) => {
        el.addEventListener('click', minimizeSidebar);
    });

    document.querySelectorAll('[data-toggle-sidebar]').forEach((el) => {
        el.removeEventListener('click', toggleSidebar);
    });
    document.querySelectorAll('[data-toggle-sidebar]').forEach((el) => {
        el.addEventListener('click', toggleSidebar);
    });
}

events.on('main.inited', () => {
    initSidebar();
});